module.exports = __webpack_public_path__ + "static/media/TaskFeature4.26ef149d.avif";